export const ALERT_WARNING  = "warning";
export const ALERT_SUCCESS  = "success";
export const ALERT_INFO     = "info";
export const ALERT_ERROR    = "error";